import moment from 'jalali-moment';
import { DateObject } from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';

export const convertGregorianToJalali = (gregorianDate) => {
  return new Date(gregorianDate).toLocaleDateString('fa-IR');
};

// this function's difference with `convertGregorianToJalali` is that this function returns jalali date with english digits.
export const getJalaliDateWithEnglishDigits = (gregorianDate) => {
  return moment(gregorianDate, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD');
};

export const getLast7Days = (locale = 'fa') => {
  const today = new Date();
  const days = [];
  for (let index = 1; index <= 7; index++) {
    days.push(
      today.toLocaleDateString(locale === 'fa' ? 'fa-IR' : 'en-US', {
        weekday: 'long',
      })
    );
    today.setDate(today.getDate() - 1);
  }
  return days;
};

export const convertDateToEnglish = (date, seprator) => {
  if (date) {
    const year = date.year;
    const mounth = date.month.number;
    const day = date.day;

    const enDate = moment
      .from(`${year}/${mounth}/${day}`, 'fa', 'YYYY/MM/DD')
      .format(`YYYY${seprator}MM${seprator}DD`);

    return enDate;
  }
};

export const getCalenderLastDays = (number) => {
  let date = new DateObject({ calendar: persian, locale: persian_fa });
  let updatedDate = new DateObject({
    calendar: persian,
    locale: persian_fa,
  }).subtract(number, 'days');
  if (number <= 1) {
    return [updatedDate];
  } else {
    return [updatedDate, date];
  }
};

//! Don't use this function
//! this function is almost a copy of above functino and added temporary, and will be removed after fixing above function problem
export const getLastDays = (number) => {
  const date = new DateObject({ calendar: persian, locale: persian_fa });
  const updatedDate = new DateObject({
    calendar: persian,
    locale: persian_fa,
  }).subtract(number, 'days');
  if (number < 1) {
    return [updatedDate];
  }
  return [updatedDate, date];
};

export const convertTimeZoneToPersian = (timeZone) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  const date = new Date(timeZone).toLocaleDateString('fa-IR', options);

  const time = new Date(timeZone).toLocaleTimeString('fa-IR');

  return `${date} ساعت ${time}`;
};

export const getTimeFromSeconds = (seconds) => {
  if (seconds) {
    let d = Number(seconds);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    // var s = Math.floor((d % 3600) % 60);
    return `${h}:${m}`;
  }
  return '0:0';
};

// returns difference time between two days by day unit
export const dateDiffInDays = (date1, date2) => {
  const dateObject1 = new Date(date1);
  const dateObject2 = new Date(date2);

  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(
    dateObject1.getFullYear(),
    dateObject1.getMonth(),
    dateObject1.getDate()
  );
  const utc2 = Date.UTC(
    dateObject2.getFullYear(),
    dateObject2.getMonth(),
    dateObject2.getDate()
  );

  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
};

// converts dates from jalali to gregorian and vice versa based on input and output formats. by default it converts jalali input to gregorian output.
export const convertDates = (
  date,
  inputFormat = 'jYYYY/jMM/jDD',
  outputFormat = 'YYYY/MM/DD'
) => {
  return moment(date, inputFormat).format(outputFormat);
};

// fixes one digit format to two digits format. for example 1373/3/2 => 1373/03/02
export const convertDateToTwoDigitsFormat = (dateString) => {
  return moment(dateString, 'jYYYY/jMM/jDD').format('jYYYY/jMM/jDD');
};

export const getFormatedData = (date, format) => {
  const formattedDate = moment(new Date(date)).format(format);

  if (formattedDate === 'Invalid date') return null;

  return formattedDate;
};
